import React from 'react';
import Icon from '../../../components/AppIcon';

const SubscriptionCard = ({ subscription, tiers, companyName }) => {
  const getTierDisplay = (tierName) => {
    const tierMap = {
      'tier_1_10': '1-10 Employees',
      'tier_10_50': '10-50 Employees',
      'tier_50_500': '50-500 Employees',
      'tier_500_plus': '500+ Employees'
    };
    return tierMap?.[tierName] || tierName;
  };

  const getStatusColor = (status) => {
    const statusColors = {
      'active': 'text-success bg-success/10',
      'suspended': 'text-warning bg-warning/10',
      'cancelled': 'text-error bg-error/10'
    };
    return statusColors?.[status] || 'text-muted-foreground bg-muted';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground mb-1">{companyName}</h2>
          <p className="text-sm text-muted-foreground">Subscription Management</p>
        </div>
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(subscription?.subscriptionStatus)}`}>
          <Icon name="CheckCircle" size={14} className="mr-1" />
          {subscription?.subscriptionStatus?.toUpperCase()}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-card rounded-lg p-4 border border-border">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Users" size={20} className="text-primary" />
            <span className="text-2xl font-bold text-foreground">{subscription?.activeEmployeeCount}</span>
          </div>
          <p className="text-sm text-muted-foreground">Active Employees</p>
        </div>

        <div className="bg-card rounded-lg p-4 border border-border">
          <div className="flex items-center justify-between mb-2">
            <Icon name="TrendingUp" size={20} className="text-secondary" />
            <span className="text-2xl font-bold text-foreground">{getTierDisplay(subscription?.currentTier)}</span>
          </div>
          <p className="text-sm text-muted-foreground">Current Tier</p>
        </div>

        <div className="bg-card rounded-lg p-4 border border-border">
          <div className="flex items-center justify-between mb-2">
            <Icon name="DollarSign" size={20} className="text-accent" />
            <span className="text-2xl font-bold text-foreground">K{subscription?.monthlyPriceKina}</span>
          </div>
          <p className="text-sm text-muted-foreground">Monthly Price</p>
        </div>

        <div className="bg-card rounded-lg p-4 border border-border">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Calendar" size={20} className="text-primary" />
            <span className="text-sm font-bold text-foreground">{formatDate(subscription?.nextBillingDate)}</span>
          </div>
          <p className="text-sm text-muted-foreground">Next Billing Date</p>
        </div>
      </div>

      <div className="bg-card rounded-lg p-4 border border-border">
        <h3 className="text-sm font-semibold text-foreground mb-3">Subscription Tiers</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {tiers?.map((tier) => {
            const isCurrentTier = tier?.tierName === subscription?.currentTier;
            return (
              <div
                key={tier?.id}
                className={`p-3 rounded-md border ${
                  isCurrentTier
                    ? 'border-primary bg-primary/5' :'border-border bg-background'
                }`}
              >
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-medium text-foreground">
                    {tier?.minEmployees}-{tier?.maxEmployees || '∞'} employees
                  </span>
                  {isCurrentTier && (
                    <Icon name="CheckCircle" size={14} className="text-primary" />
                  )}
                </div>
                <p className="text-lg font-bold text-foreground">K{tier?.monthlyPriceKina}/mo</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
